import {
    CatalogMetricSlugs,
    CatalogReferenceDataSlugs,
} from "~/modules/catalog/types";

// // // //

const CATALOG_SLUGS = new Set<string>([
    ...Object.values(CatalogMetricSlugs),
    ...Object.values(CatalogReferenceDataSlugs),
]);

export function isCatalogSlug(slug: string): boolean {
    return CATALOG_SLUGS.has(slug);
}
